<template>
  <div id="home" class="">
    <div class="bannerprincipal pb-2">
      <div class="container">
        <div class="row">
          <div class="col-8 offset-2 col-md-6 offset-md-3 offset-md-0 h-100 pt-5">
            <div class="">
              <div class="d-flex justify-content-center align-items-center">
                <div
                  class="mt-3 zindex10"
                  data-aos="fade"
                  data-aos-delay="200"
                >
                  <img
                    class="img-fluid"
                    src="../assets/imgs/flow/llevamos.png"
                    alt="Domino's Pizza"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-8 offset-2 col-md-6 offset-md-3 offset-md-0 h-100">
            <div class="">
              <div class="d-flex justify-content-center align-items-center">
                <div
                  class="mt-3 zindex10"
                  data-aos="fade"
                  data-aos-delay="200"
                >
                  <img
                    class="img-fluid"
                    src="../assets/imgs/flow/premio-wm-ba.jpg"
                    alt="Domino's Pizza"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-8 offset-2 col-md-6 offset-md-3 offset-md-0 h-100">
            <div class="">
              <div class="d-flex justify-content-center align-items-center">
                <div
                  class="mt-3 zindex10"
                  data-aos="fade"
                  data-aos-delay="200"
                >
                  <img
                    class="img-fluid"
                    src="../assets/imgs/flow/participa.png"
                    alt="Domino's Pizza"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    


    <Footer></Footer>

  

    <div
      class="overlayticket overlay-sucursal"
      v-if="overlay_sucursal === true"
    >
      <div class="bg-overlay" @click="toggleSucursal"></div>
      <div class="ticket shadow rounded bg-moradooscuro">
        <div class="head">
          <div
            class="cerrar p-2 d-block fG pointer amarillo monts"
            @click="toggleSucursal"
          >
            cerrar
          </div>
        </div>
        <div class="body text-center w-100">
          <div class="titulo fG amarillo bold">Número de sucursal:</div>
          <img
            class="img-fluid p-4"
            src="../assets/imgs/homeins/ticket-sucursal.jpg"
            alt="Domino's Pizza"
          />
        </div>
      </div>
    </div>

    <div
      class="overlayticket overlay-sucursal"
      v-if="overlay_transaccion === true"
    >
      <div class="bg-overlay" @click="toggleTransaccion"></div>
      <div class="ticket shadow rounded bg-moradooscuro">
        <div class="head">
          <span
            class="cerrar p-2 d-block fG pointer amarillo monts"
            @click="toggleTransaccion"
            >cerrar</span
          >
        </div>
        <div class="body text-center w-100">
          <div class="titulo fG amarillo bold">Número de trnsacción:</div>
          <img
            class="img-fluid p-4"
            src="../assets/imgs/homeins/ticket-transaccion.jpg"
            alt="Domino's Pizza"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commentsCollection } from "@/firebase";
import { mapState } from "vuex";
import moment from "moment";
import AOS from "aos";
import swal from "sweetalert2";

import Footer from "@/components/Footer";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      post: {
        content: "",
      },
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      file: null,
      monedero: "",
      no_transaccion: null,
      no_sucursal: null,
      disponibles: [
        
      ],
      dulceria: [
        
      ],
      overlay_transaccion: false,
      overlay_sucursal: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
  },
  methods: {
    // async jugar() {
    //   this.$store.commit(
    //     "setTicketID",
    //     this.userProfile.ultimo_ticket_registrado
    //   );
    //   this.$router.push("/dinamica");
    // },
    fileSelected: function ($event) {
      this.file = $event.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.
        var preview = document.getElementById("preview");
        var image = document.createElement("img");
        image.src = e.target.result;
        preview.innerHTML = "";
        preview.appendChild(image);
        console.log(preview);

        swal.fire(
          "Bien",
          "Recuerda conservar tus tickets de compra, da click en continuar para participar.",
          "success"
        );
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.file);
    },
    async tomarTrivia() {
      if (this.file == null) {
        swal.fire(
          "Oops",
          "Sube la foto de un ticket antes de continuar...",
          "warning"
        );
        return;
      }

      await this.$store.dispatch("registroTicket", {
        file: this.file,
      });

      this.file = null;
      var preview = document.getElementById("preview");
      preview.innerHTML = "";
    },
    toggleSucursal() {
      this.overlay_sucursal = !this.overlay_sucursal;
    },
    toggleTransaccion() {
      this.overlay_transaccion = !this.overlay_transaccion;
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>

<style lang="scss" scoped>
.overlayticket {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100000;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  .bg-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
  }
  .ticket {
    width: 50%;
    margin: 0 25%;
    .head {
      width: 100%;
      .cerrar {
        text-align: right;
        cursor: pointer;
        user-select: none;
      }
    }
    .body {
    }
  }
}
</style>
